/** Normalize a URL/API page value to a 1-based page number string. */
export function normalizePageParam(value, fallback = 1) {
  const parsed = parseInt(value, 10);
  if (!Number.isFinite(parsed) || parsed < 1) {
    return String(fallback);
  }
  return String(parsed);
}
